import React, { useEffect } from "react";

export default function Modal({ title, subtitle, onClose, children, footer, maxWidth = "max-w-xl" }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-md" onClick={onClose} />
      <div className={`relative w-full ${maxWidth} rounded-3xl border border-white/10 bg-black shadow-2xl animate-in fade-in-0 zoom-in-95`}>
        <div className="flex items-start justify-between px-6 py-5">
          <div>
            <h2 className="text-2xl font-bold text-white">{title}</h2>
            {subtitle && <p className="mt-1 text-sm font-normal text-gray-400">{subtitle}</p>}
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Cerrar"
            className="rounded-full p-1.5 text-white/50 transition-colors hover:bg-white/10 hover:text-white"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="max-h-[85vh] overflow-y-auto px-6 pb-6">{children}</div>
        {footer && (
          <div className="flex justify-end gap-3 border-t border-white/10 px-6 py-4">{footer}</div>
        )}
      </div>
    </div>
  );
}